import { useNavigate } from "react-router-dom";
import { Sparkles, XCircle } from "lucide-react";
import { useHideEmergentBadge } from "@/hooks/useHideEmergentBadge";

export default function BillingCancelled() {
  const navigate = useNavigate();
  useHideEmergentBadge();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f9f9fb] p-6" data-testid="billing-cancelled-page">
      <div className="bg-white border border-[#e5e5eb] rounded-3xl p-8 sm:p-10 max-w-md w-full text-center shadow-sm">
        <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.24em] font-semibold text-[#002fa7] mb-3">
          <Sparkles className="w-3 h-3" /> SparkLoop
        </div>
        <div className="w-16 h-16 rounded-full bg-[#fff4d6] text-[#7a5a00] flex items-center justify-center mx-auto mb-4">
          <XCircle className="w-8 h-8" strokeWidth={2} />
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tighter leading-tight mb-3">
          Checkout cancelled.
        </h1>
        <p className="text-[#5a5a65] mb-6 leading-relaxed">
          No charge was made. You can start the checkout again any time from your dashboard.
        </p>
        <button
          data-testid="billing-cancelled-continue-btn"
          onClick={() => navigate("/merchant", { replace: true })}
          className="w-full h-14 rounded-2xl bg-[#002fa7] hover:bg-[#002585] text-white font-bold text-base"
        >
          Back to dashboard
        </button>
      </div>
    </div>
  );
}
